import React, { Component } from "react";
import '../css/topRight_UI.css';

class TopRightUI extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }

    }
    render() {
        return (
            <div id="topRight_UI">
                <button className="logOutButton" onClick={this.props.logOut}>Se déconnecter</button>
            </div>
        );
    }
}


export default TopRightUI;
